import { Injectable } from '@angular/core'
import { ChtmModel } from '../chtm/chtm.model'
import { CmodalModel } from './cmodal.model'

@Injectable({
  providedIn: 'root'
})
export class CmodalService {
  cm: any = $('#cmodal')
  models: CmodalModel[]
  model: CmodalModel
  dyn: any
  callback

  constructor() {
    this.models = []
    this.model = null
  }

  add(model: CmodalModel) {
    this.models.push(model)
  }

  implement(id: string, _opt: any, _dyn: any, callback: any) {
    console.log(450000, id)
    let cmdl = this.models.find(x => x.id == id)
    if (!cmdl) return false
    this.show()

    // if (_opt) mdl.opt = _opt
    this.dyn = _dyn
    this.callback = callback
    // document.getElementById(mdl.model.id).dispatchEvent(new CustomEvent('cmodal_implement', { detail: { model: mdl.model } }))
    let g: any = $('#' + id + ' tbody tr td:first-child input').prop('checked', false)
    if (cmdl.model.sela == 2) cmdl.model.dats_sel = []
    let thos = this
    setTimeout(() => {
      this.model = cmdl

      $('#cmodal').on('hidden.bs.modal', function () {
        // thos.model.model.sta = 1
        thos.model.model.disf = _opt.disf_rollback
        thos.model.model.cform = _opt.cform_rollback
        if (thos.model) thos.model.model.dat_edt = null
        if (thos.model) thos.model.model.sta = 1
      })
    }, 200)
  }

  unimplement() {
    // let cm: any = $('#cmodal')
    // cm.modal('hide')
    if (this.model) this.model.model.sta = 1
    this.hide()
    this.model = null
  }

  apply() {
    this.callback(this.model.model, this.model.model.dats_vis.filter(x => x[1]))
    var thos = this
    document.getElementById(this.model.model.id).dispatchEvent(new CustomEvent('cmodal_apply', { detail: { model: thos.model.model } }))
    this.unimplement()
  }

  show() {
    let cm: any = $('#cmodal')
    cm.modal('show')
  }

  hide() {
    // this.model.model.sta = 1
    let cm: any = $('#cmodal')
    cm.modal('hide')
  }

  clear() {
    this.cm.find('.modal-dialog').css('width', '')
    // this.title.html('')
    // this.descript.html('')
    // this.content.html('')
    // this.masterHeader = ''
    // if (this.onclosed != null) this.onclosed(this.outData)
  }

  document = function (tit: string, htm: string, option: any) {
    this.show()
    this.model = null
    let cmodal = this.models.find(x => x.id == '202206281529')

    if (!cmodal) {
      cmodal = new CmodalModel('chtm', '202206281529', tit, new ChtmModel())
      this.models.push(cmodal)
    }

    cmodal.model.id = '202206281529'
    cmodal.model.tit = tit
    cmodal.model.cmp = 4
    cmodal.model.srt = 1
    cmodal.model.htm = htm
    cmodal.model.dis = 5
    cmodal.model.ctyp = 'chtm'
    // if (!option) option = {};

    // if (option.width) this.modal.find('.modal-dialog').css('width', option.width)
    // this.title = title
    // this.content.html(html)
    // if (option.masterHeader)
    //   this.masterHeader = option.masterHeader
    // else
    //   this.masterHeader = ''
    setTimeout(() => {
      this.model = cmodal
    }, 200);
  }
}